import 'reflect-metadata';
import { EntityBase } from "../_models/EntityBase";
import { EntityConstructor } from "../services/DependecyInjection.provider";

export interface ProviderRegistration<T extends EntityBase> {
  providerClass: any;
  entityType: EntityConstructor<T> | 'ALL_ENTITIES';
}
export const GlobalProviderRegistry: ProviderRegistration<any>[] = [];

export const EntityClassRegistry = new Map<string, new () => EntityBase>();
export interface RegisterOptions<T extends EntityBase> {
  entityType?: EntityConstructor<T> | 'ALL_ENTITIES';

  isModelEntity?: boolean;

  entityName?: string;

  namespace?: string; // optionnel
}

//
//  Decorateur unique pour les providers et les entites :
//      - pour enregistrer les providers
//      - ou enregistrer les entites dans EntityClassRegistry
// 
export function Register<T extends EntityBase>(
  options: RegisterOptions<T> | EntityConstructor<T> | 'ALL_ENTITIES' = {}
) {
  if (typeof options === 'function' || options === 'ALL_ENTITIES') {
    options = { entityType: options as any };
  }

  const ENTITY_NAMESPACE_KEY = 'custom:entity_namespace';

  const {
    entityType = 'ALL_ENTITIES' as const,
    isModelEntity = false,
    entityName,
    namespace = ''
  } = options as RegisterOptions<T>;

  return function (target: any) {
    //  Sauvegarde du nom original AVANT toute modification
    const originalName = entityName || target.name || 'AnonymousEntity';

    // Comportement existant
    GlobalProviderRegistry.push({
      providerClass: target,
      entityType
    });

    // Enregistrement comme entite
    if (isModelEntity) {
      const baseName = entityName || target.name || 'AnonymousEntity';
      const key = namespace ? `${namespace}.${baseName}` : baseName;
        EntityClassRegistry.set(key, target);
      EntityClassRegistry.set(baseName, target);

    }

    // on stocke le namespace via reflect-metadata
    if (namespace) {
      Reflect.defineMetadata(ENTITY_NAMESPACE_KEY, namespace, target);
    }
    // Si pas de namespace, on supprime une eventuelle meta heritee
    else if (Reflect.hasMetadata(ENTITY_NAMESPACE_KEY, target)) {
      Reflect.deleteMetadata(ENTITY_NAMESPACE_KEY, target);
    }

    // correction du nom de l'entite avec le nom original (pour eviter les suffixes entiers) 
    Object.defineProperty(target, 'name', {
      value: originalName,
      writable: false,
      configurable: true
    });

    // Retourner explicitement le constructeur original
    return target;
  };
}


